export const me = {
  pathname: '/me'
}

export const userDetails = {
  pathname: ({ userId }) => `/users/${userId}`,
  headers: (headers, { apiKey }) => headers.set('X-ApiKey', apiKey)
}

export const orgQuota = {
  pathname: ({ userId }) => `/users/${userId}/groups?attributes=quotas`,
  headers: (headers, { apiKey }) => headers.set('X-ApiKey', apiKey),
}
